<template>
  <div class="loader">
    <transition
      appear
      @before-appear="beforeAppear"
      @appear="appear">
      <h2 class="loader__text">
        Broad-minded Destination Wedding Studio.
        <br>Take off your journey through places, local suppliers, Italian traditions.
      </h2>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import anime from 'animejs';
import { SplitText } from '@/scripts/SplitText';

export default {
  name: 'Loader',
  computed: {
    ...mapState(['resourcesLoaded', 'pageIndex', 'fontLoaded']),
  },
  methods: {
    addWheelListener() {
      this.$el.addEventListener('wheel', this.close, true);
      this.$el.addEventListener('touchmove', this.close, true);
    },
    close() {
      this.$el.removeEventListener('wheel', this.close, true);
      this.$el.removeEventListener('touchmove', this.close, true);
      this.$eventHub.$emit('startNavigation');
    },
    animation(splitted, done) {
      return anime({
        targets: splitted.lines,
        autoplay: false,
        opacity: {
          value: [0, 1],
          easing: 'easeInQuart',
          duration: 1500,
        },
        scale: [0.8, 1],
        translateY: [60, 0],
        easing: 'easeOutQuart',
        duration: 3000,
        delay: anime.stagger(300, { start: 2500 }),
        complete() {
          splitted.revert();
          done();
        },
      });
    },
    beforeAppear(el) {
      anime.set(el, { opacity: 0 });
    },
    appear(el, done) {
      setTimeout(() => {
        const splitted = new SplitText(el, {
          type: 'lines',
          linesClass: 'text-line',
        });

        anime.set(el, { opacity: 1 });
        anime.set(splitted.lines, { translateZ: 1 });
        const animation = this.animation(splitted, done);
        animation.play();
      }, 200);
    },
  },
  created() {
    this.$eventHub.$once('resourcesIsLoaded', this.addWheelListener);
  },
};
</script>

<style scoped lang="scss">
.loader {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  display: flex;
  justify-content: center;
  align-items: center;

  &__text {
    padding: 0 2rem;

    flex-basis: 100vw;

    text-align: center;
    font-style: italic;

    @include mq(mobileL) {
      padding: 0;
      flex-basis: 26em;
    }

    & ::v-deep.text-line {
      will-change: opacity, transform;
    }
  }
}
</style>
